<div class="header">
  <div>
    <h2>{{ 'menu.admin.users' | translate }}</h2>
  </div>
</div>

<nb-card>
  <nb-card-body>
    <app-table
      #table
      rowIdKey="id"
      [title]="title"
      [columns]="columns"
      [data]="data"
      [rowActions]="rowActions"
      [globalActions]="globalActions"
      (event)="onEvent($event)"
      [maxVisibleItems]="100"
    ></app-table>
  </nb-card-body>
</nb-card>
